var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('home-page-hero'),_vm._v(" "),_c('home-page-cta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }